import api from '../../services/api.js'
import TokenService from '../../services/tokenService.js'

const state = {
  username: null,
  roles: [],
  rememberMe: null,
  userId: null,
  impersonateUsername: null,
  impersonateRoles: []
}

const getters = {
  isAuthenticated: (state) => state.username != null,
  username: (state) => state.username,
  roles: (state) => state.impersonateUsername ? state.impersonateRoles : state.roles,
  userId: (state) => state.userId,
  isAdmin: (state) => state.isAdmin,
  isRememberMe: (state) => state.rememberMe,
  impersonateUsername: (state) => state.impersonateUsername
}

const actions = {

  async LogIn ({commit}, data) {
    await api({
      method: 'POST',
      url: '/api/login',
      data: JSON.stringify(data),
      headers: { 'content-type': 'application/json' }

    }).then(response => {
      commit('didLogIn', response)
    })
  },

  refreshToken ({ commit }, response) {
    commit('didRefreshToken', response)
  },

  setRememberMe ({commit}, rememberMe) {
    commit('setRememberMe', rememberMe)
  },

  leaveImpersonateMode ({commit}) {
    commit('leaveImpersonateMode')
  },

  setImpersonateMode ({commit}, data) {
    commit('setImpersonateMode', data)
  },

  async LogOut ({ commit }) {
    commit('didLogOut')
  }
}

const mutations = {

  didLogIn (state, response) {
    const roles = response.data.roles
    if ((roles.includes('ROLE_ADMIN') || roles.includes('ROLE_PROFESSIONAL'))) {
      // eslint-disable-next-line no-throw-literal
      throw 'Locked'
    } else {
      TokenService.setUser(response.data)
      state.username = response.data.username
      state.roles = response.data.roles
      state.userId = response.data.id
      state.isAdmin = state.roles.includes('ROLE_ADMIN')
    }
  },

  didRefreshToken (state, response) {
    TokenService.setUser(response.data)
  },

  didLogOut (state) {
    TokenService.removeUser()
    TokenService.removeImpersonate()
    state.username = null
    state.roles = []
    state.userId = null
    state.isAdmin = false
    state.impersonateUsername = null
    state.impersonateRoles = []
  },

  setRememberMe (state, rememberMe) {
    state.rememberMe = rememberMe
  },

  leaveImpersonateMode (state) {
    state.isAdmin = true
    state.impersonateUsername = null
    state.impersonateRoles = []
  },

  setImpersonateMode (state, data) {
    state.isAdmin = false
    state.impersonateUsername = data.username
    state.impersonateRoles = data.roles
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js